module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-outlined.woff2?0ba49c096a77b67734434cebcaf2e14d";